<template>
    <div class="banner-image-area position-relative">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-6 order-1 order-lg-1 wow move-up">
                    <div class="banner-image__media">
                        <img src="../assets/img/banners/simple_service_1.png" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="col-lg-6 order-2 order-lg-2 wow move-up">
                    <div class="banner-image__content">
                        <div class="section-title-wrapper mb-20">
                            <h2 class="section-title font-weight--light">All-in-one responsive app.</h2>
                        </div>
                        <div class="banner-image__text section-space--mb_40">
                        Costruita con le migliori tecnologie e in continuo aggiornamento, la sua interfaccia in HTML5 si adatta a qualsiasi dispositivo senza bisogno di installare e aggiornare nulla, basta un comune browser.
                        Può essere installata presso la sede del cliente o nella nostra server farm e utilizzata come servizio.
                        </div>                                                
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'BannerOne',
    };
</script>
